import styled, { keyframes } from "styled-components";

/*
 * Footer, v2 redizajn: --bg-sidebar površina, border-top 1px --border
 * (bez narandžaste linije i dekorativnih patterna).
 */

export const FooterWrapper = styled.footer`
  background: var(--bg-sidebar);
  border-top: 1px solid var(--border);
  padding: 3.5rem 0 0;
  margin-top: auto;

  .container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr;
  gap: 2.5rem;
  padding-bottom: 2.5rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterSection = styled.div`
  min-width: 0;

  h3 {
    color: var(--text-muted);
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    margin: 0 0 1rem;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
  }
`;

export const FooterLink = styled.span`
  color: var(--text-secondary);
  font-size: 0.92rem;
  cursor: pointer;
  transition: color 0.18s ease;
  width: fit-content;

  &:hover {
    color: var(--brand);
  }
`;

export const BrandBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

/* Znak + МРЧ u jednom redu, isti lockup i hover animacija kao u headeru:
   spin znaka (JS klasom, uvek se odvrti do kraja), talas slova, brand boja. */
export const BrandRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-family: var(--font-display);
  font-size: 1.35rem;
  letter-spacing: 0.02em;
  color: var(--text-primary);
  cursor: pointer;
  user-select: none;
  transition: color 0.2s ease;
  line-height: 1;
  width: fit-content;

  &:hover {
    color: var(--brand);
  }
`;

const markSpin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const letterWave = keyframes`
  0% { transform: translateY(0) scale(1); }
  40% { transform: translateY(-4px) scale(1.12); }
  100% { transform: translateY(0) scale(1); }
`;

export const BrandMark = styled.span`
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  transition: filter 0.25s ease;

  svg {
    width: 100%;
    height: 100%;
    display: block;
    will-change: transform;
  }

  /* Spin se pokreće JS klasom (na mouseenter) i UVEK se odvrti do kraja,
     ne živi u :hover pravilu, pa nema skoka kad se hover prekine na pola. */
  svg.spin {
    animation: ${markSpin} 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  }

  ${BrandRow}:hover & {
    filter: drop-shadow(0 0 9px rgba(255, 107, 53, 0.65));
  }

  @media (prefers-reduced-motion: reduce) {
    svg.spin {
      animation: none;
    }
  }
`;

export const BrandName = styled.span`
  display: inline-flex;
`;

export const BrandLetter = styled.span`
  display: inline-block;

  > span {
    display: inline-block;
  }

  ${BrandRow}:hover & > span {
    animation: ${letterWave} 0.45s cubic-bezier(0.2, 0.8, 0.2, 1);
    animation-delay: calc(var(--i) * 70ms);
  }

  @media (prefers-reduced-motion: reduce) {
    ${BrandRow}:hover & > span {
      animation: none;
    }
  }
`;

export const BrandTagline = styled.p`
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
  max-width: 280px;
  margin: 0;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: var(--text-secondary);
  font-size: 0.92rem;
  margin-bottom: 0.55rem;

  svg {
    color: var(--brand);
    flex-shrink: 0;
    font-size: 0.85rem;
  }
`;

export const SocialMedia = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.25rem;
`;

export const SocialLink = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.18s ease;

  svg {
    font-size: 1rem;
  }

  &:hover {
    color: var(--brand);
    border-color: var(--brand);
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1.25rem 0;
  border-top: 1px solid var(--border);

  p {
    color: var(--text-muted);
    font-size: 0.82rem;
    margin: 0;
  }
`;

export const LegalLinks = styled.div`
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;

  span {
    color: var(--text-muted);
    font-size: 0.82rem;
    cursor: pointer;
    transition: color 0.18s ease;

    &:hover {
      color: var(--text-primary);
    }
  }
`;
